import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase";

import Home from "@/client/components/Home";
//import Navigation from "@/components/Navigation";
import Login from "@/client/components/Login";
import Dashboard from "@/client/components/Dashboard";
import Settings from "@/client/components/Settings";

Vue.use(VueRouter);

let router = new VueRouter({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "Home",
            component: Home,
			meta: {
				title: 'Jessica and Krystal',
				description: 'Jessica and Krystal - A fanbase community',
				metaTags: [
					{
						name: 'description',
						content: 'Home page of Jessica and Krystal'
					}
				]
			}
		},
		{
			path: "*",
			redirect: "/"
		},
		{
			path: "/login",
			name: "Login",
			component: Login
		},
		{
			path: "/dashboard",
			name: "Dashboard",
			component: Dashboard,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: "/settings",
			name: "Settings",
			component: Settings,
			meta: {
				requiresAuth: true
			}
		}
	]
});

router.beforeEach((to, from, next) => {
	//Change title of pages
	const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
    if (!nearestWithMeta) return next();
    nearestWithMeta.meta.metaTags.map(tagDef => {
			const tag = document.createElement('meta');
      Object.keys(tagDef).forEach(key => {
				tag.setAttribute(key, tagDef[key]);
			});
			tag.setAttribute('data-vue-router-controlled', '');
			return tag;
    })
		.forEach(tag => document.head.appendChild(tag));
    next();

	//Configure user authorization
	const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
	const currentUser = firebase.auth().currentUser;

	if (requiresAuth && !currentUser) {
		next("/login");
	}
	else if (requiresAuth && currentUser) {
		next();
	}
	else {
		next();
    }
});

export default router;
